import { diasUteis, parseNumero } from "../calculos";
import { F } from "../gerencialFields";
import { startOfDay, toDate } from "../status";

// I-078: alinhado com GUIA-TOC-PCP.md (40% default conservador para
// moveis sob medida). Valor anterior 0.35 superestimava throughput em
// ~5pp ate calibracao do gestor.
export const PCT_MATERIAIS_DEFAULT = 0.4;

function entregaAmbiente(amb) {
  // Data real de saída do ambiente: CN CARREGAMENTO (sem fórmula).
  // CO ENTREGA_CLIENTE é fórmula WORKDAY — fica preenchida desde a aprovação,
  // então não representa entrega real e infla o throughput.
  return toDate(amb?.[F.CARREGAMENTO]);
}

function inicioMesDe(date) {
  const d = new Date(date.getFullYear(), date.getMonth(), 1);
  d.setHours(0, 0, 0, 0);
  return d;
}

function fimMesDe(date) {
  const d = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  d.setHours(23, 59, 59, 999);
  return d;
}

export function calcularThroughputMes(
  ambientes,
  {
    hoje = new Date(),
    pctMateriais = PCT_MATERIAIS_DEFAULT,
    metaGanhoRS = 0,
    metaAmbientes = 0,
  } = {}
) {
  const today = startOfDay(hoje) || new Date();
  const inicioMes = inicioMesDe(today);
  const fimMes = fimMesDe(today);
  const lista = Array.isArray(ambientes) ? ambientes : [];

  let valorEntregue = 0;
  let qtdEntregue = 0;

  for (const amb of lista) {
    const entrega = entregaAmbiente(amb);
    if (!entrega) continue;
    if (entrega < inicioMes || entrega > fimMes) continue;
    qtdEntregue++;
    valorEntregue += parseNumero(amb?.[F.VALOR_DO_AMBIENTE]) || 0;
  }

  const ganho = valorEntregue * (1 - pctMateriais);
  const diasUteisTotaisMes = diasUteis(inicioMes, fimMes) || 0;
  const diasUteisCorridos = diasUteis(inicioMes, today) || 0;
  const diasUteisRestantes = Math.max(0, diasUteisTotaisMes - diasUteisCorridos);

  const valorRestanteParaMeta = Math.max(
    0,
    metaGanhoRS - ganho
  );
  const valorBrutoRestante =
    1 - pctMateriais > 0 ? valorRestanteParaMeta / (1 - pctMateriais) : 0;
  const ritmoNecessarioRS =
    diasUteisRestantes > 0 ? valorBrutoRestante / diasUteisRestantes : null;

  const ambientesRestantesParaMeta = Math.max(0, metaAmbientes - qtdEntregue);
  const ritmoAmbientes =
    diasUteisRestantes > 0
      ? ambientesRestantesParaMeta / diasUteisRestantes
      : null;

  return {
    valorEntregue,
    qtdEntregue,
    ganho,
    pctMateriais,
    metaGanhoRS,
    metaAmbientes,
    pctMetaGanho: metaGanhoRS > 0 ? ganho / metaGanhoRS : null,
    pctMetaAmbientes: metaAmbientes > 0 ? qtdEntregue / metaAmbientes : null,
    diasUteisTotaisMes,
    diasUteisCorridos,
    diasUteisRestantes,
    ritmoNecessarioRS,
    ritmoAmbientes,
    inicioMes,
    fimMes,
  };
}

function isoKey(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function historicoMensalThroughput(
  ambientes,
  { hoje = new Date(), meses = 6, pctMateriais = PCT_MATERIAIS_DEFAULT } = {}
) {
  const today = startOfDay(hoje) || new Date();
  const lista = Array.isArray(ambientes) ? ambientes : [];
  const totalMeses = Math.max(1, Math.floor(meses));

  const resultado = [];
  for (let offset = totalMeses - 1; offset >= 0; offset--) {
    const ref = new Date(today.getFullYear(), today.getMonth() - offset, 1);
    const ano = ref.getFullYear();
    const mes = ref.getMonth();
    let valor = 0;
    let qtd = 0;
    for (const amb of lista) {
      const entrega = toDate(amb?.[F.CARREGAMENTO]);
      if (!entrega) continue;
      if (entrega.getFullYear() !== ano || entrega.getMonth() !== mes) continue;
      qtd++;
      valor += parseNumero(amb?.[F.VALOR_DO_AMBIENTE]) || 0;
    }
    resultado.push({
      ano,
      mes,
      label: `${String(mes + 1).padStart(2, "0")}/${String(ano).slice(-2)}`,
      valorEntregue: valor,
      qtdEntregue: qtd,
      ganho: valor * (1 - pctMateriais),
    });
  }

  return resultado;
}

export function burndownDoMes(ambientes, { hoje = new Date() } = {}) {
  const today = startOfDay(hoje) || new Date();
  const inicioMes = inicioMesDe(today);
  const fimMes = fimMesDe(today);
  const lista = Array.isArray(ambientes) ? ambientes : [];

  const counts = new Map();
  for (const amb of lista) {
    const entrega = entregaAmbiente(amb);
    if (!entrega || entrega < inicioMes || entrega > fimMes) continue;
    const key = isoKey(entrega);
    counts.set(key, (counts.get(key) || 0) + 1);
  }

  const pontos = [];
  let acumulado = 0;
  const cursor = new Date(inicioMes);
  while (cursor <= fimMes) {
    const key = isoKey(cursor);
    const isFuturo = cursor > today;
    if (!isFuturo) acumulado += counts.get(key) || 0;
    pontos.push({
      data: new Date(cursor),
      acumulado: isFuturo ? null : acumulado,
    });
    cursor.setDate(cursor.getDate() + 1);
  }

  return { pontos, totalAteHoje: acumulado, inicioMes, fimMes };
}
